import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import createSagaMiddleware, { END } from 'redux-saga';

import { addConnection, getContext, getPluginContext } from 'kea';

import { keaSaga, startSaga, cancelSaga } from './saga';
import { createSaga } from './create-saga';
import { select } from 'redux-saga/effects';

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$useLegacyUnbound = _ref.useLegacyUnboundActions,
      useLegacyUnboundActions = _ref$useLegacyUnbound === undefined ? true : _ref$useLegacyUnbound;

  return {
    name: 'saga',

    defaults: function defaults() {
      return {
        get: undefined,
        fetch: undefined,
        workers: undefined,
        saga: undefined
      };
    },

    buildOrder: {
      connectSagas: { after: 'connect' }
    },

    buildSteps: {
      // 1) Add to .connectedSagas any generator functions in input.sagas || input.connect.sagas
      // 2) Connect logic stores from input.sagas || input.connect.sagas into .connections
      connectSagas: function connectSagas(logic, input) {
        var connectedSagas = [];

        if (input.sagas || input.connect && input.connect.sagas) {
          var sagas = [].concat(input.sagas || [], input.connect && input.connect.sagas || []);

          for (var _iterator = sagas, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
            var _ref2;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref2 = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref2 = _i.value;
            }

            var saga = _ref2;

            if (saga._isKea) {
              addConnection(logic, saga(logic.props || {}));
            } else {
              connectedSagas.push(saga);
            }
          }
        }

        if (connectedSagas.length > 0) {
          logic.connectedSagas = connectedSagas;
        }
      },
      saga: function saga(logic, input) {
        // add .fetch() & .get() to all logic stores if there are any selectors
        if (logic.selectors && _Object$keys(logic.selectors).length > 0) {
          logic.get = _regeneratorRuntime.mark(function _callee(key) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return select(key ? logic.selectors[key] : logic.selector, logic.props);

                  case 2:
                    return _context.abrupt('return', _context.sent);

                  case 3:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          });

          logic.fetch = _regeneratorRuntime.mark(function _callee2() {
            var results,
                keys,
                i,
                _args2 = arguments;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    results = {};
                    keys = Array.isArray(_args2[0]) ? _args2[0] : _args2;
                    i = 0;

                  case 3:
                    if (!(i < keys.length)) {
                      _context2.next = 10;
                      break;
                    }

                    _context2.next = 6;
                    return logic.get(keys[i]);

                  case 6:
                    results[keys[i]] = _context2.sent;

                  case 7:
                    i++;
                    _context2.next = 3;
                    break;

                  case 10:
                    return _context2.abrupt('return', results);

                  case 11:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          });
        }

        // add .saga and .workers (if needed)
        if (input.start || input.stop || input.takeEvery || input.takeLatest || input.workers || logic.connectedSagas) {
          createSaga(logic, input, useLegacyUnboundActions);
        }
      }
    },

    events: {
      beforeReduxStore: function beforeReduxStore(options) {
        var sagaContext = getPluginContext('saga');
        sagaContext.sagaMiddleware = createSagaMiddleware();
        options.middleware.push(sagaContext.sagaMiddleware);
      },
      afterReduxStore: function afterReduxStore(options, store) {
        var _getPluginContext = getPluginContext('saga'),
            sagaMiddleware = _getPluginContext.sagaMiddleware;

        store._keaSagaTask = sagaMiddleware.run(keaSaga);
        store._sagaMiddleware = sagaMiddleware;
      },
      afterMount: function afterMount(logic) {
        logic.saga && startSaga(logic.pathString, logic.saga);
      },
      beforeUnmount: function beforeUnmount(logic) {
        logic.saga && cancelSaga(logic.pathString);
      },
      beforeCloseContext: function beforeCloseContext(context) {
        var _ref3 = context || getContext(),
            store = _ref3.store;

        store && store.dispatch(END);
        if (store && store._keaSagaTask && store._keaSagaTask.isRunning()) {
          store._keaSagaTask.cancel();
        }
      }
    }
  };
});